import { isEmpty, isNil, keys, reduce } from "lodash";
import { HouseholdFormData, ReasonFormData } from "../models/classes/ApplicationStep1.class";
import { InputError } from "../hooks/use-form";
import { checkDOB } from "./form-helper";
import { ApplicationStep5 } from "../models/classes/ApplicationStep5.class";
import { OwnershipReasonEnum } from "../models/enum/ownership-reason.enum";
import { MyInfo } from "../models/polymer/MyInfo.model";
import { ResidentialStatusEnum } from "../models/enum/residential-status.enum";
import { HoldingFormData } from "../models/polymer/HoldingFormData.model";
import { HoldingOwner } from "../models/polymer/HoldingOwner.model";
import { HoldingOccupier } from "../models/polymer/HoldingOccupier.model";
import { ReasonEnum } from "../models/enum/reason.enum";
import { ApplicationStep2 } from "../models/classes/ApplicationStep2.class";
import { ApplicationStep3, HDBSolicitor, LegalRepresentation, TenancyInCommon } from "../models/classes/ApplicationStep3.class";
import { HoldingTypeEnum } from "../models/enum/holding-type.enum";
import { SolicitorTypeEnum } from "../models/enum/solicitor-type.enum";
import { StampDutyValuationEnum } from "../models/enum/stamp-duty-valuation.enum";
import { SharedValidators } from "./validators/shared/validators";
import { MaritalStatusEnum } from "../models/enum/marital-status.enum";
import { IDTypeEnum } from "../models/enum/id-type.enum";
import { LoanTypeEnum } from "../models/enum/loan-type.enum";
import { DemiseAdministratorDoc } from "../models/enum/demise-administrator-doc.enum";


export const validateMyInfo = (myinfo: MyInfo | undefined) => {
  const errors: any = reduce(keys(myinfo), (result, field: any, _index: number) => {
    let validation = validateMyInfoFields(myinfo, field);
    return { ...result, [field.toString()]: validation };
  }, {});
  return errors;
}



//8 June - Remodelling



//=====
//GROUPED : validate-Reason
  export const validateReason = (values: ReasonFormData, additionalFields: any) => {
    const fields = keys(values);
    const errors: any = reduce(
      fields,
      (result, field: string) => {
        let validatedResult = validateReasonFields(values, field, additionalFields);
        return { ...result, [field]: validatedResult };
      },
      {}
    );
        return errors;
  };

  const handleHaveFinalJudgement = (values:any,value:any) => {
    if (values['change_ownership_reason'] === OwnershipReasonEnum.divorce) {
      if (isNil(value)) {
        return { isValid: false };
      } else if (isEmpty(value)) {
        return { isValid: false, message: "This is a required field." };
      }else{
        return { isValid: true };
      }
    }
    else{
      return { isValid: true };
    }
  }

  const handleSubmitContent = (values:any,value:any) => {
    if (values['change_ownership_reason'] === OwnershipReasonEnum.divorce) {
      if (isNil(value)) {
        return { isValid: false };
      }else{
        return { isValid: true };
      }
    }
    else{
      return { isValid: true };
    }
  }

  const changeOwnershipReasonAndDivorce = (values:any,value:any,field:any) => {
    if (values['change_ownership_reason'] === OwnershipReasonEnum.divorce) {
      if(field === "final_judgement_date" && values["have_final_judgement"] === "no") {
        return { isValid: true };
      }
      return SharedValidators.BasicEmpty(value);
    }else{
      return { isValid: true };
    }
  }

  const handleDateOfMarriage = (values:any,value:any) => {
    if (values['change_ownership_reason'] === OwnershipReasonEnum.inclusion_due_to_marriage || values['change_ownership_reason'] === OwnershipReasonEnum.moving_out_due_to_marriage) {
      return SharedValidators.BasicEmpty(value);
    }else{
      return { isValid: true };
    }
  }

  const handleOutstandingLoanAmount = (values:any,value:any) => {
    if (values['has_outstanding_loan'] === "yes") {
      return SharedValidators.BasicEmpty(value);
    }
    else if(values['has_outstanding_loan'] === "no"){
      return { isValid: false };
    }
    else{
      return { isValid: true };
    }
  }

  const handleAdministrationItems = (values:any, value:any) => {
    if (values['validation_exempted_fields'].includes('has_administration_items')) {
      return { isValid: true}
    }

    if (isNil(value) || value === DemiseAdministratorDoc.no_document) {
      return { isValid: false }
    }

    return { isValid: true }
  }

  const handleIsBeneficiaryProposedOwners = (values:any, value:any) => {
    if ((isNil(value) || value === "") && !values['validation_exempted_fields'].includes('is_beneficiary_proposed_owners')) {
      return { isValid: false };
    }else{
      return { isValid: true };
    }
  }

  const handleLossOfCitizenship = (value:any,name: string) => {
    if(name === "date_of_renunciation"){
      return SharedValidators.BasicEmpty(value);
    }else{
      return { isValid: true };
    }
  }

  const handleDeathDate = (values:any,value:any) => {
    if (isNil(value) && !values['validation_exempted_fields'].includes('death_date')) {
      return { isValid: false };
    } else if (isEmpty(value) && !values['validation_exempted_fields'].includes('death_date')) {
      return { isValid: false, message: "This is a required field." };
    } else {
      return { isValid: true };
    }
  }

  const handleChangeOwnershipReason = (values:any,value:any) => {
    if (isNil(value)) {
      return { isValid: false };
    } else if (isEmpty(value)) {
      return { isValid: false, message: "This is a required field." };
    }
    else if(value === OwnershipReasonEnum.moving_out_due_to_marriage){
      if(isEmpty(values['date_of_marriage'])){
        return { isValid: false, message: "This is a required field." };
      }
    }
    else if(value === OwnershipReasonEnum.moving_out_others){
      console.log("VALIDATOR - CALL API");
    }else{
      return { isValid: true };
    }
  }

  export const validateReasonFields = (values: any, name: string, additionalFields:any) => {
    const { financialHardshipAdditionalChecking } = additionalFields;
    
    const value = values[name];
    let error: InputError | undefined = { isValid: true };

    if (values['reason'] === ReasonEnum.marital_status_reason_value) {
      switch (name) {
        case "change_ownership_reason":
          error = SharedValidators.BasicEmpty(value);
          break;
        case "have_final_judgement":
          error = handleHaveFinalJudgement(values,value);
          break;
        case "final_judgement_date":
          error = changeOwnershipReasonAndDivorce(values,value,name);
          break;
        case "submit_content":
          error = handleSubmitContent(values,value);
          break;

        case "date_of_court_order":
        case "amount_stated_in_court_order":
        case "cpf_refund":
          error = changeOwnershipReasonAndDivorce(values,value,name);
          break;

        case "date_of_marriage":
          error = handleDateOfMarriage(values,value);
          break;

      }
    }
    else if (values['reason'] === ReasonEnum.financial_circumstances_reason_value && financialHardshipAdditionalChecking === 1) {
      switch (name) {
        case "has_outstanding_loan":
          error = SharedValidators.BasicEmpty(value);
          break;
        case "outstanding_loan_amount":
          error = handleOutstandingLoanAmount(values,value);
          break;
      }
    }
    else if(values['reason'] === ReasonEnum.demise_current_owner_reason_value) {
      switch (name) {
        case "has_administration_items":
          error = handleAdministrationItems(values, value);
          break;
        case "is_beneficiary_proposed_owners":
          error = handleIsBeneficiaryProposedOwners(values, value);
          break;               
        case "death_date":
          error = handleDeathDate(values,value);
          break;
      }
    }
    else if(values['reason'] === ReasonEnum.loss_of_citizenship_reason_value) {
      error = handleLossOfCitizenship(value,name);
    }
    else if(values['reason'] === ReasonEnum.owner_moving_out_reason_value && name === "change_ownership_reason") {
      error = handleChangeOwnershipReason(values,value);
    }
    else if(values['reason'] === ReasonEnum.health_reasons_reason_value) {
      //Validation for health reasons
    }
   else if(name === "reason"){
      error = SharedValidators.BasicEmpty(value);
    }
    return error;
  };

//=====
//END GROUPED : validate-Reason

//========
export const validateHousehold = (values: HouseholdFormData) => {
  const fields = keys(values);
  const errors: any = reduce(
    fields,
    (result, field: string) => {
      let validatedResult = validateHouseholdFields(values, field);
      return { ...result, [field]: validatedResult };
    },
    {}
  );
  return errors;
};

export const validateHouseholdFields = (values: any, name: string) => {
  const value = values[name];
  let error: InputError | undefined = { isValid: true };

  switch (name) {
    case "check_has_private_property":
    case "check_has_dispose_property":
      error = SharedValidators.BasicUndefined(value);
      
    break;
  }
  return error;
};

//========


//=====
//GROUPED : household-structure
export const validateHoldingOwnerOccupier = (values: HoldingFormData) => {
  const errors: any = reduce(keys(values), (result, field: any, _index: number) => {
    let validation: any = { isValid : true };
    if(field === "holding_owners"){
      validation = validateHoldingOwnersFields(values.holding_owners);
    }
    else if(field === "holding_occupiers"){
      validation = validateHoldingOccupiersFields(values.holding_occupiers);
    }
    return { ...result, [field.toString()]: validation};
  }, {});
  return errors;
}
/**
 * @description This function is to validate the holding owners fields, this function breaks into 2 subProcess, "New" and "Existing". Each subprocess has its own requirement
 *
 * @param proposed_uinfin_arr Note: an Array of the PROPOSED Uinfin. Used for Uinfin checking for existing
 * @param is_proposed Note: boolean of whether this holding owner is added to Proposed.
 *
 * @function validateNewHoldingOwnersMyInfoFields accepts the myinfo, proposed_uinfin_arr, and is_proposed
 *
 * @param values Pass the holding Owners from the validateHoldingOwnerOccupier function.
 *
 * @returns
 */
export const validateHoldingOwnersFields = (values?: HoldingOwner[]) => {
  let proposed_uinfin_arr = values ? values?.filter(e=>e.is_proposed === true)?.map(e => e.myinfo?.uinfin ? e.myinfo?.uinfin : '') : [];
  return values?.map((owner) => {
    const proposedOwner = owner.is_proposed ? [] : proposed_uinfin_arr;
    const errors: any = reduce(keys(owner), (result, field: any, _index: number) => {
      let validation;
      validation = handleValidateHoldingOwnerFields(field,owner,proposed_uinfin_arr,proposedOwner);
      if(validation === undefined){
        validation = { isValid : true };
      }
      return {...result, [field.toString()]: validation}
    },{});
    return errors;
  });
}

const handleValidateHoldingOwnerFields = (field:any,owner:HoldingOwner,proposed_uinfin_arr:string[],proposedOwner:string[]) => {
  if(field.toString() === "myinfo"){
    if(owner.type === "new"){
      return validateNewHoldingOwnersMyInfoFields( owner.myinfo, proposed_uinfin_arr, owner.is_proposed );
    }
    else if(owner.type === "existing"){
      return validateExistingHoldingOwnersMyInfoFields(-1, owner.myinfo, proposedOwner, true);
    }
  }
  if(field.toString() === "spr_obtained_date"){
    if(owner.myinfo.residential_status === ResidentialStatusEnum.pr) {
      return SharedValidators.SprObtainedDate(owner.spr_obtained_date, false);
    }
  }
}


export const validateHoldingOccupiersFields = (values?: HoldingOccupier[]) => {
  let proposed_uinfin_arr = values ? values?.filter(e=>e.is_proposed === true)?.map(e => e.myinfo?.uinfin ? e.myinfo?.uinfin : '') : [];
  return values?.map((owner) => {
    const errors: any = reduce(keys(owner), (result, field: any, _index: number) => {
      const proposedOwner = owner.is_proposed ? [] : proposed_uinfin_arr;
      let validation;
      validation = handleValidateHoldingOccupiersFields(field,owner,proposed_uinfin_arr,proposedOwner)
      if(validation === undefined){
        validation = { isValid : true };
      }
      return {...result, [field.toString()]: validation}
    },{});
    return errors;
  });
}

const handleValidateHoldingOccupiersFields = (field:any,owner:HoldingOccupier,proposed_uinfin_arr:string[],proposedOwner:string[]) => {
  if(field.toString() === "myinfo"){
    if(owner.type === "new"){
      return validateNewHoldingOccupiersMyInfoFields( owner.myinfo, proposed_uinfin_arr, owner.is_proposed, undefined, owner.id_type );
    }
    else if(owner.type === "existing"){
      //!22June - currently using owner myinfo fields validation
      return validateExistingHoldingOwnersMyInfoFields(-2, owner.myinfo, proposedOwner, false, true, owner.id_type);
    }
  }
}


export const validateExistingHoldingOwnersMyInfoFields = (formType:any = -1, myinfo?: MyInfo, proposed_uinfin_arr?:string[], dobLimitChecking?: boolean, requireNricCheck?:boolean, idType?: IDTypeEnum, is_proposed?: boolean) => {
  /**
   * NOTE: formType will by default be -1, formType will only be used for holding propose owners now. So 1,3,5 will be the expected value to differentiate different validation on gender, nationality, race etc.
   * NOTE: formType will be -2 if we are validating occupier with this function, validating sex, nationality(added 20240219)
   */
  const allowNricCheck = requireNricCheck ?? true;
  const errors: any = reduce(keys(myinfo), (result, field: any, _index: number) => {
    let validation: any = { isValid : true };
    if(field === "residential_status" || field === "dob" || field === "uinfin" || field === "marital_status"){
      validation = validateMyInfoFields(myinfo, field, proposed_uinfin_arr, dobLimitChecking, false, undefined, allowNricCheck, idType ? true: false, idType, !is_proposed);
    }
    if((formType === 1 || formType === -2 ) && (field === "sex" || field === "race" || field === "nationality")){
      validation = validateAdditionalMyInfoFields(myinfo, field);
    }
    return {...result, [field.toString()]: validation};
  },{});
  return errors;
}
export const validateExistingHoldingOccupierMyInfoFields = (myinfo?: MyInfo, proposed_uinfin_arr?:string[], idType?: IDTypeEnum, is_proposed?: boolean) =>{
  const errors: any = reduce(keys(myinfo), (result, field: any, _index: number) => {
    let validation: any = { isValid : true };
    if(field === "residential_status" || field === "dob" || field === "uinfin" || field === "marital_status"){
      validation = validateMyInfoFields(myinfo, field, proposed_uinfin_arr, false, false, [], true, true, idType, !is_proposed );
    } else if(field === "sex" || field === "nationality" || field === "race"){
      validation = validateAdditionalMyInfoFields(myinfo, field);
    }
    return {...result, [field.toString()]: validation};
  },{});
  return errors;
}
/**
 * @description This function is one of the  2 subProcess from validateHoldingOwnersFields.
 * What is does is to validate all myinfo fields EXCEPT email and mobile_no.
 * NOTE: if is_proposed is TRUE, Uinfin field will be not be validated and will always be valid.
 *
 * @param myinfo Pass the Myinfo field from parent function.
 * @param proposed_uinfin_arr NOTE : an Array of the PROPOSED Uinfin. Used for Uinfin checking for existing
 * @param is_proposed Note: boolean of whether this holding owner is added to Proposed.
 *
 * @returns
 */
const validateNewHoldingOwnersMyInfoFields = ( myinfo?: MyInfo, proposed_uinfin_arr?: string[], is_proposed?: boolean, initialHouseholdNrics?:string[]) =>{
  const errors: any = reduce(keys(myinfo), (result, field: any, _index: number) => {
    let validation: any = { isValid : true };
    if(field !== "email" && field !== "mobile_no"){
      if(!(is_proposed === true && field === "uinfin")){
        validation = validateMyInfoFields(myinfo, field, proposed_uinfin_arr, true, true, initialHouseholdNrics, true, false, undefined, !is_proposed);
      }
    }
    return {...result, [field.toString()]: validation};
  },{});
  return errors;
}
const validateNewHoldingOccupiersMyInfoFields = ( myinfo?: MyInfo, proposed_uinfin_arr?: string[], is_proposed?: boolean, initialHouseholdNrics?:string[], idType?: IDTypeEnum) =>{
  const errors: any = reduce(keys(myinfo), (result, field: any, _index: number) => {
    let validation: any = { isValid : true };
    if(field === "sex" || field === "nationality" || field === "race"){
      validation = validateAdditionalMyInfoFields(myinfo, field);
    }
    else if(field !== "email" && field !== "mobile_no"){
      if(is_proposed === true || is_proposed === undefined){
        validation = validateMyInfoFields(myinfo, field, proposed_uinfin_arr, false, false, initialHouseholdNrics, true, true, idType, !is_proposed);
      }
    }
    return {...result, [field.toString()]: validation};
  },{});
  return errors;
}
//=====
//END GROUPED : household-structure


// GROUPED : financing-form
//=====
  export const validateFinancing = (values: ApplicationStep2) => {
    const fields = keys(values);
    const errors: any = reduce(
      fields,
      (result, field: string) => {
        let validatedResult = validateFinancingFields(values, field);
        return { ...result, [field]: validatedResult };
      },
      {}
    );
    return errors;
  };

  export const validateFinancingFields = (values: any, name: string) => {
    const value = values[name];

    const isCurrentLoanBank = values["current_loan_type"] === LoanTypeEnum.bank_loan
    const isNewLoanBank = values["new_loan_type"] === LoanTypeEnum.bank_loan

    const validResult: InputError = { isValid: true };

    switch(name) {
      case "current_loan_amount": {
        return isCurrentLoanBank ? SharedValidators.BasicIsNil(value) : validResult
      }
      case "new_loan_type": {
        return SharedValidators.BasicEmptyUndefined(value)
      }
      case "new_loan_amount": {
        if (!isNewLoanBank) {
          return validResult;
        }
        
        if (Number(value) === 0) {
          return { isValid: false, message: "New loan cannot be 0" };
        }
        
        return SharedValidators.BasicEmptyUndefined(value);
      }
    }

    return validResult;
  };

//=====
//END GROUPED : financing-form


// GROUPED : Conveyancing-form
//=====
export const validateConveyancing = (values: ApplicationStep3, additionalFields: any) => {
  const { is_holding_type_proposed_legal_required, is_remission, is_proposed_conveyancing_hdb, is_current_direct_conveyancing, is_proposed_direct_conveyancing  } = additionalFields;
  const fields = keys(values);
  const errors: any = reduce(
    fields,
    (result, field: string) => {
      if(field === "tenancy_in_common"){
        //When holding type is tenancy in common, then need to check share
          let validatedResult = validateTenancyInCommon(values, field);
          let validatedTotalSharesResult = validateTenancyInCommonTotalShares(values, field);
          return { ...result, ...validatedTotalSharesResult ,[field]: validatedResult };
      }
      if(field === "current"){
          let validatedResult = validateLegalRepresentation(values, field, true);
          return { ...result, [field]: validatedResult };
      }else if(field === "proposed"){
          //is_holding_type_proposed_legal_required meaning when login user is outgoing owner for some reasons, therefore this section will not show,
         //therefore validation not required
         if(is_holding_type_proposed_legal_required){
          let validatedResult = validateLegalRepresentation(values, field, true);
          return { ...result, [field]: validatedResult };
         }else{
          return { ...result }
         }
      }
      else{
        //holding type not required when login user is outgoing owner for some reasons, therefore holding type section will not show,
        //therefore validation not required
        const validationVoidedFields = ["holding_type", "is_holding_type_confirm", "proposed_solicitor_type"];
        if(!is_holding_type_proposed_legal_required && validationVoidedFields.includes(field)){
          return {...result};
        }
        //is_holding_type_proposed_legal_required meaning when login user is outgoing owner for some reasons, so this section will not show,
        if((!is_holding_type_proposed_legal_required || is_remission) && field === "valuation"){
          return {...result, [field]: {isValid: true} };
        }
        let validatedResult = validateConveyancingFields(values, field);
        return { ...result, [field]: validatedResult };
      }
    },
    {}
  );
  return errors;
};


export const validateConveyancingFields = (values: any, name: string) => {
  const value = values[name];

  let error: InputError | undefined = { isValid: true };

  switch (name) {
    case "holding_type":
    case "current_solicitor_type":
    case "proposed_solicitor_type":
    case "valuation": 
      error = SharedValidators.BasicEmptyUndefined(value);
      break;
    case "is_holding_type_confirm":
      error = SharedValidators.BasicBoolean(value);
      break;
    case "estimated_market_value": 
      if(values['valuation'] === StampDutyValuationEnum.own_opinion){
         error = SharedValidators.BasicEmptyUndefined(value);
      }
   }

  return error;
};

export const validateLegalRepresentation = (values:any, name:string, allow_conveyancing:boolean = true) =>{
  const legal_representation:LegalRepresentation = values[name];

  const errors: any = reduce(keys(legal_representation), (result, field: any, _index: number) => {
      let validation: any = { isValid : true };

      if(values[`${name}_solicitor_type`] === SolicitorTypeEnum.conveyancing_hdb_solicitor){
        if(field === "hdb_solicitor"){
          validation = validateHdbSolicitor(values[name], field);
          return {...result, [field.toString()]: validation}
        }
      }
      
      if(values[`${name}_solicitor_type`] === SolicitorTypeEnum.conveyancing_private_solicitor){
        if(field === "conveyancing_private_solicitor"){
          validation = validatePrivateSolicitor(values[name], field);
          return {...result, [field.toString()]: validation}
        }
      }

      if(values[`${name}_solicitor_type`] === SolicitorTypeEnum.hdb_solicitor){
        if(field === "hdb_solicitor"){
          validation = validateHdbSolicitor(values[name], field);
          return {...result, [field.toString()]: validation}
        }
        //This is to check the conveyancing_private_solicitor field, only validate when the represented_same_solicitor is false, and is_confirm is true;
        if(allow_conveyancing && values[name].hdb_solicitor.represented_same_solicitor === false && values[name].hdb_solicitor.is_confirm === true && field === "conveyancing_private_solicitor"){
          validation = validatePrivateSolicitor(values[name], field);
          return {...result, [field.toString()]: validation}
        }
      }
      if(values[`${name}_solicitor_type`] === SolicitorTypeEnum.private_solicitor){
        if(field === "private_solicitor"){
          validation = validatePrivateSolicitor(values[name], field);
          return {...result, [field.toString()]: validation}
        }
        //This is to check the conveyancing_private_solicitor field, only validate when the represented_same_solicitor is false, and is_confirm is true;
        if(allow_conveyancing && values[name].private_solicitor.represented_same_solicitor === false && values[name].private_solicitor.is_confirm && field === "conveyancing_private_solicitor"){
          validation = validatePrivateSolicitor(values[name], field);
          return {...result, [field.toString()]: validation}
        }
      }
      return {...result}
    },{});
    return errors;

}

const validateHdbSolicitor = (values:any, name:string) =>{
  const hdb_solicitor:HDBSolicitor = values[name];
  const errors: any = reduce(keys(hdb_solicitor), (result, field: any, _index: number) => {
    let validation = validateHdbSolicitorFields(hdb_solicitor, field);
    return { ...result, [field.toString()]: validation };
  }, {});
  return errors;
}
export const validateHdbSolicitorFields = (values:any, name:string) =>{
  const value = values[name];
  let error: InputError | undefined = { isValid: true };

  switch (name) {
    case "is_confirm":
    case "tnc":
      error = SharedValidators.BasicBoolean(value);
      break;
    }

  return error;
}


export const validatePrivateSolicitor = (values:any, name:string) =>{
  const hdb_solicitor:HDBSolicitor = values[name];
  const errors: any = reduce(keys(hdb_solicitor), (result, field: any, _index: number) => {
    let validation = validatePrivateSolicitorFields(hdb_solicitor, field);
    return { ...result, [field.toString()]: validation };
  }, {});
  return errors;
}

export const validatePrivateSolicitorFields = (values:any, name:string) =>{
  const value = values[name];
  let error: InputError | undefined = { isValid: true };

  switch (name) {
    case "is_confirm":
      error = SharedValidators.BasicBoolean(value);
      break;
    case "name_of_firm":
    case "uen":
      error = SharedValidators.Basic(value);
      break;
    case "email_of_solicitor":
      error = SharedValidators.Email(value);
      break;
    }

  return error;
}

export const validateTenancyInCommonTotalShares = (values:any, name:string) =>{
  const value:TenancyInCommon[] = values[name];
  if(Array.isArray(value)){
      const totalShares = value.map(item => Number(item.shares ?? 0)).reduce((a, b) => a + b, 0);
      if(totalShares > 999){
        return {total_shares: {isValid: false}};
      }
  }

  return {total_shares: {isValid: true}};
};

export const validateTenancyInCommon = (values:any, name:string) =>{

    const value:TenancyInCommon[] = values[name];
    if(Array.isArray(value)){
      return value?.map((tenancy) => {
        const errors: any = reduce(keys(tenancy), (result, field: any, _index: number) => {
          if(values['holding_type'] === HoldingTypeEnum.tenancy_in_common){
            let validation = validateTenancyInCommonFields(tenancy, field);
            return { ...result, [field.toString()]: validation };
          }
          else{
            return { ...result, [field.toString()]: { isValid: true } };
          }
        }, {});
        return errors;
      })
    }
    else{
      return { isValid:false };
    }

}

const validateTenancyInCommonFields = (values:any, name:string) =>{
  const value = values[name];
  let error: InputError | undefined = { isValid: true };
  if(name === "shares"){
    error = SharedValidators.BasicEmpty(value);
  }
  return error;
}
//=====
//END GROUPED : Conveyancing-form



//GROUPED : Review Endorse-form
//=====
export const validateReviewEndorse = (values: ApplicationStep5) => {
  const fields = keys(values);
  const errors: any = reduce(
    fields,
    (result, field: string) => {
      let validatedResult = validateReviewEndorseFields(values, field);
      return { ...result, [field]: validatedResult };
    },
    {}
  );
  return errors;
};

const validateReviewEndorseFields = (values: any, name: string) => {
  const value = values[name];

  let error: InputError | undefined = { isValid: true };
  if(name === "input_verified"){
    error = SharedValidators.BasicBoolean(value);
  }
  return error;
};




//=====
//END GROUPED : Review Endorse-form

//=====
//GROUPED : Review Endorse - HoldingForm
export const validateReviewHoldingOwnerOccupier = (values: HoldingFormData, additional_values: any) => {

  const errors: any = reduce(keys(values), (result, field: any, _index: number) => {
    let validation: any = { isValid : true };
    if(field === "holding_owners"){
      validation = validateReviewHoldingOwnersAndOccupiersFields(values.holding_owners, additional_values);
    }
    else if(field === "holding_occupiers"){
      validation = validateReviewHoldingOwnersAndOccupiersFields(values.holding_occupiers, additional_values);
    }
    return { ...result, [field.toString()]: validation};
  }, {});
  return errors;
}

export const validateReviewHoldingOwnersAndOccupiersFields = (values?: HoldingOwner[] | HoldingOccupier[], additional_values?: any) =>{
  return values?.map((owner) => {
    const errors: any = reduce(keys(owner), (result, field: any, _index: number) => {
      let validation: any = { isValid : true };

      if(field.toString() === "myinfo"){
        validation = validateMyInfoContactEmail( owner.myinfo, additional_values );
      }
      return {...result, [field.toString()]: validation}
    },{});
    return errors;
  });
}

export const validateMyInfoContactEmail = ( myinfo?: MyInfo, additional_values?: any) =>{
  const errors: any = reduce(keys(myinfo), (result, field: any, _index: number) => {
    let validation: any = { isValid : true };
    if(field === "email" || field === "mobile_no" || (additional_values?.isLoginOutgoing && field === "marital_status")){
      validation = validateMyInfoFields(myinfo, field);
    }
    return {...result, [field.toString()]: validation};
  },{});
  return errors;
}

//Ended GROUPED : Review Endorse - HoldingForm
//=====


export const validateMyInfoFields = (values: any, name: string, proposed_uinfin_arr?: string[], dobLimitChecking?:boolean, citizenshipChecking?: boolean, initialHouseholdNrics?:string[], requireNricCheck?:boolean, requireNricCheckBasedOnType?: boolean, idType?: IDTypeEnum, isNew?: boolean) => {
  const allowCitizenshipCheck = citizenshipChecking ?? true;
  const allowDobCheck = dobLimitChecking ?? true;
  const allowNricCheck = requireNricCheck ?? true;
  const allowNricCheckBasedOnType = requireNricCheckBasedOnType ?? false;
  const value = values[name];
  let error: InputError | undefined = { isValid: true };
  switch (name) {
    case "uinfin":
      if(allowNricCheck){
        if(!allowNricCheckBasedOnType){
          error = SharedValidators.Uinfin(value);
        }else {
          if(idType === "UIN" || idType === "FIN"){
            error = SharedValidators.Uinfin(value)
          }else if(idType === "MIC"){
            error = SharedValidators.MalaysianId(value)
          }else if(idType === "PPN" || idType === "SPN" || idType === "FBC"){
            error = SharedValidators.OtherId(value)
          }else {
            error = SharedValidators.Basic(value);
          }
        }
      }
      if (proposed_uinfin_arr && proposed_uinfin_arr.length > 0 && value.length === 9 && isNew && proposed_uinfin_arr.filter(item => item === value).length >= 1){
        error = { isValid: false, message: "We already have an existing record of the same NRIC number belonging to another proposed owner." };
      }
      if(initialHouseholdNrics && initialHouseholdNrics.length > 0 && initialHouseholdNrics.includes(value)){
        error = { isValid: false, message: "We already have an existing record of the same NRIC number belonging to another proposed owner." };
      }
      break;
    case "residential_status":
      error = SharedValidators.Basic(value);
      if (allowCitizenshipCheck && value === ResidentialStatusEnum.not_applicable) {
        error = { isValid: false, message: "Only a Singapore citizen or Permanent Resident may be included as an owner of an HDB flat." };
      }
      break;
    case "dob":
      if(allowDobCheck){
        error = SharedValidators.Dob(value);
      }
      else{
        error = SharedValidators.BasicEmpty(value);
      }
      break;
    case "name":
    case "marital_status":
      error = SharedValidators.BasicEmpty(value);
      break;
    case "email":
      error = SharedValidators.Email(value);
      break;
    case "mobile_no":
      error = SharedValidators.Mobile(value);
      break;          

  }
  return error;
};

export const validateAdditionalMyInfoFields = (values: any, name: string) => {
  const value = values[name];
  let error: InputError | undefined = { isValid: true };
  switch (name) {
    case "sex":
    case "race":
    case "nationality":
      error = SharedValidators.Basic(value);
      break;       
  }
  return error;
};

const validatePR = (owner:any,field:any) => {
  if(owner.myinfo.residential_status === ResidentialStatusEnum.pr) {
    return SharedValidators.SprObtainedDate(owner.spr_obtained_date, false);
  }
}

const handleValidateMyInfo = (formType:any, owner:any,proposed_nric:any,proposedNRIC:any, initialHouseholdNrics?: string[]) => {
  if(owner.type === "new"){
    return validateNewHoldingOwnersMyInfoFields( owner.myinfo, proposed_nric, owner.is_proposed, initialHouseholdNrics );
  }
  else if(owner.type === "existing"){
    //NOTE: when isProposed, we ignore then nric existed error;
    return validateExistingHoldingOwnersMyInfoFields(formType, owner.myinfo, proposedNRIC, true);
  }
}



export const validateIndividualHoldingOwner = (owner: HoldingOwner, additional_values: any) => {
  /**
   * FormType = 1 = main applicant as login user + current owners
   * FormType = 3 = current owners
   * FormType = 5 = new users
   */
  const { formType, reasonValues, proposed_nric, isProposed, isToShowChildCareControl, initialHouseholdNrics } = additional_values;
  const isMarried = owner.myinfo.marital_status === MaritalStatusEnum.married;


  const errors: any = reduce(keys(owner), (result, field: any, _index: number) => {
    let proposedNRIC = isProposed ? [] : proposed_nric;
    let validation: any = { isValid : true };

    if(field.toString() === "myinfo"){
      validation = handleValidateMyInfo(formType, owner, proposed_nric, proposedNRIC, initialHouseholdNrics)
    }

    if(field.toString() === "children_care_and_control" && isToShowChildCareControl){
      if(!owner.children_care_and_control){
        validation = { isValid: false, message: "This is a required field." }
      }
    }

    if(field.toString() === "spr_obtained_date"){
      validation = validatePR(owner,field);
    }

    if(formType === 1){
      if(field.toString() === "gross_monthly_income"){
        let value = owner.gross_monthly_income;
        if (!value) {
          validation = { isValid: false, message: "This is a required field."};
        } 
      }
    }

    if(isMarried){
      if(field.toString() === "spouse"){
        if(owner['spouse_id_type'] === "UIN" || owner['spouse_id_type'] === "FIN"){
          validation = SharedValidators.Uinfin(owner.spouse)
        }else if(owner['spouse_id_type'] === "MIC"){
          validation = SharedValidators.MalaysianId(owner.spouse)
        }else if (owner['spouse_id_type'] === "PPN" || owner['spouse_id_type'] === "SPN" || owner['spouse_id_type'] === "FBC"){
          validation = SharedValidators.OtherId(owner.spouse)
        }else{
          validation = SharedValidators.Basic(owner.spouse)
        }
      }
      if(field.toString() === "spouse_id_type"){
        validation = SharedValidators.Basic(owner.spouse_id_type)
      }
    }

    return {...result, [field.toString()]: validation}
  },{});
  return errors;
};

export const validateIndividualHoldingOccupier = (occupier: HoldingOccupier, additional_values: any) => {

  const {isFirst, proposed_nric, initialHouseholdNrics} = additional_values;

  const isMarried = occupier.myinfo.marital_status === MaritalStatusEnum.married;

  const errors: any = reduce(keys(occupier), (result, field: any, _index: number) => {
    let validation: any = { isValid : true };

    
    if((isFirst && field.toString() === "relationship_with_owner") || (occupier.is_related === true && field.toString() === "relationship_with_owner")){
      validation = SharedValidators.Basic(occupier.relationship_with_owner);
    }

    // if(field.toString() === "id_type"){
    //   validation = SharedValidators.Basic(occupier.id_type);
    // }
    
    
    
    if(field.toString() === "myinfo"){
      if(occupier.type === "new"){
        validation = validateNewHoldingOccupiersMyInfoFields( occupier.myinfo, proposed_nric, occupier.is_proposed, initialHouseholdNrics, occupier.id_type );
      }
      else if(occupier.type === "existing"){
        validation = validateExistingHoldingOccupierMyInfoFields(occupier.myinfo, proposed_nric, occupier.id_type, occupier.is_proposed)
      }
    }
    if(isMarried){
      if(field.toString() === "spouse"){
        if(field.toString() === "spouse"){
          if(occupier['spouse_id_type'] === "UIN" || occupier['spouse_id_type'] === "FIN"){
            validation = SharedValidators.Uinfin(occupier.spouse)
          }else if(occupier['spouse_id_type'] === "MIC"){
            validation = SharedValidators.MalaysianId(occupier.spouse)
          }else if (occupier['spouse_id_type'] === "PPN" || occupier['spouse_id_type'] === "SPN" || occupier['spouse_id_type'] === "FBC"){
            validation = SharedValidators.OtherId(occupier.spouse)
          }else{
            validation = SharedValidators.Basic(occupier.spouse);
          }
        }
      }
      if(field.toString() === "spouse_id_type"){
        validation = SharedValidators.Basic(occupier.spouse_id_type)
      }
    }
    return {...result, [field.toString()]: validation}
  },{});
  return errors;
};


